import { Component, Input } from '@angular/core';
import { SrsProxyVoteComponent } from '../../../srs-proxy-vote/srs-proxy-vote.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DateFormatPipe } from '../../../../../controls/pipes/date-format.pipe';
import { ISrsBallotVote } from '../../../../shared/models/sr/srs-vote';

@Component({
    selector: 'app-srs-history-column',
    templateUrl: './srs-history-column.component.html',
    styleUrl: './srs-history-column.component.scss',
    standalone: false
})
export class SrsHistoryColumnComponent {
  @Input() vote: ISrsBallotVote | null = null;
  @Input() isUserPmOrAboveOrHoSD: boolean = false;
  @Input() afterSaveSubject: Subject<string> = new Subject<string>();
  @Input() ballotInOpenOrDecisionPendingStatus: boolean = false;

  isEligible: boolean = false;
  lastUpdated: string = '';

    constructor(
      private _modalService: NgbModal,
      private dateFormatPipe: DateFormatPipe
    ) {}

  ngOnInit(): void {
    if (this.vote && this.vote.lastUpdated) {
      this.isEligible = this.vote.isEligible;
      this.lastUpdated = this.dateFormatPipe.transform(this.vote.lastUpdated);
    }
  }


  openProxyVoteModal() {
    const modalRef = this._modalService.open(SrsProxyVoteComponent, { size: 'xl', centered: true });
    modalRef.componentInstance.committeeMembers = [this.vote];
    modalRef.result.then(r => {
      if(r) {
        this.afterSaveSubject.next(r);
      }
    })
  }
}
